// extracted by mini-css-extract-plugin
export var container = "footer-module--container--3JFS4";
export var fax = "footer-module--fax--JjWBY";
export var footer_text = "footer-module--footer_text--fLdA7";
export var inline = "footer-module--inline--KWVUn";
export var link = "footer-module--link--sMT7G";
export var links = "footer-module--links--MrYfJ";
export var phone_and_fax = "footer-module--phone_and_fax--25-rP";
export var social_links = "footer-module--social_links--ug6wH";
export var twitter = "footer-module--twitter--9zQ1A";